import {useRouter} from 'next/router';
import {MdExitToApp, MdPerson} from 'react-icons/md';
import {LOGIN} from '../../../../config/constants/routes';
import {QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE} from '../../../../core/entities/login/constants';
import {getMailAuthLinkWithParamsHooks} from '../../../services/getMailAuthLinkWithParamsHooks';
import {CommonLink} from '../../CommonLink';

export const AuthActionMenu: React.FC = () => {
  const router = useRouter();
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});

  const items = [
    {
      id: 'login',
      icon: <MdExitToApp size={20} />,
      href: `${LOGIN}?${QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE}=${router.asPath}`,
      label: 'ログイン',
    },
    {
      id: 'registration',
      icon: <MdPerson size={20} />,
      href: mailAuthLink,
      label: '無料会員登録',
    },
  ];

  return (
    <ul className="bg-white text-black-1 text-sm divide-line flex flex-col divide-y py-4 px-12 pc:w-[197px] w-full">
      {items.map((item) => {
        const {id, icon, href, label} = item;

        return (
          <li key={id || item.href}>
            <CommonLink href={href} className="flex items-center p-8">
              <div className="mr-8">{icon}</div>
              <div>{label}</div>
            </CommonLink>
          </li>
        );
      })}
    </ul>
  );
};
